import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    this.setState({ collapsed: true });
  };

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-lg navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
          <NavbarBrand tag={Link} to="/" className="d-flex align-items-center">
            <img 
              src="/logo.png" 
              alt="Iglesia CBR Logo" 
              height="40" 
              className="me-2"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span style={{ color: 'var(--secondary-gold)', fontWeight: 'bold' }}>
              Iglesia CBR
            </span>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink 
                  className="text-dark" 
                  onClick={() => this.scrollToSection('about')}
                  style={{ cursor: 'pointer' }}
                >
                  Quiénes Somos
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  className="text-dark" 
                  onClick={() => this.scrollToSection('schedule')}
                  style={{ cursor: 'pointer' }}
                >
                  Horarios
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  className="text-dark" 
                  onClick={() => this.scrollToSection('events')}
                  style={{ cursor: 'pointer' }}
                >
                  Eventos
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  className="text-dark" 
                  onClick={() => this.scrollToSection('gallery')}
                  style={{ cursor: 'pointer' }}
                >
                  Galería
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  className="text-dark" 
                  onClick={() => this.scrollToSection('contact')}
                  style={{ cursor: 'pointer' }}
                >
                  Contacto
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
